import React, { Component } from 'react'
import Canvas from './Canvas'
import TemplateEditorUtils from '~/Common-Objects/TemplateEditor/Utils'
import DeviceToggle from './DeviceToggle'

export default class DragDropStage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            canvasScreenType: 0
        }

        this.clickStage = this.clickStage.bind(this)
    }

    clickStage(event) {
        let okToContinue = TemplateEditorUtils.checkMouseUpHasSelection(event, 'clickStage')
        if (!okToContinue) {
            return
        }
        this.props.deselectElement()
    }
    componentDidMount() {}

    render() {
        let style = {}

        if (this.props.templateJson && this.props.templateJson.globalVariables) {
            if (
                this.props.templateJson.globalVariables.bodyBg &&
                this.props.templateJson.globalVariables.bodyBg.value
            ) {
                style.backgroundColor = this.props.templateJson.globalVariables.bodyBg.value
            }
        }
        const screenType =
            this.props.canvasScreenType != null ? this.props.canvasScreenType : this.state.canvasScreenType

        return (
            <>
                <div className='dndEditorv2-canvas-holder' data-canvas-screen-type={screenType}>
                    <div className='dndEditorv2-canvas-header'>
                        <div className='dndEditorv2-canvas-header-devices'>
                            <DeviceToggle
                                device={screenType}
                                setDevice={(tab) => {
                                    if (this.props.onCanvasScreenTypeChange) this.props.onCanvasScreenTypeChange(tab)
                                    else this.setState({ canvasScreenType: tab })
                                }}
                                showTablet={this.props.type === 'landingPage'}
                            />
                        </div>
                    </div>
                    <div
                        className='contentArea'
                        id='dd_contentArea'
                        onClick={this.clickStage}
                        style={{
                            ...style,
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            minHeight: 0,
                            minWidth: 0,
                            width: '100%',
                            maxWidth: '100%',
                            overflow: 'auto'
                        }}
                    >
                        <div className='canvas' style={{ maxWidth: this.props.screenSize }}>
                            <Canvas
                                elementsData={this.props.templateJson}
                                updateElementsData={this.props.updateElementsData}
                                clickElement={this.props.clickElement}
                                deselectElement={this.props.deselectElement}
                                selectedElement={this.props.selectedElement}
                                saveFaveColor={this.props.saveFaveColor}
                                updateBlocks={this.props.updateBlocks}
                                showGuideLines={this.props.showGuideLines}
                                templateId={this.props.templateId}
                                templateType={this.props.type}
                                canvasScreenType={screenType}
                                setDragging={this.props.setDragging}
                                campaign={this.props.campaign}
                                isLandingPage={this.props.isLandingPage}
                                landingPageId={this.props.landingPageId}
                            />
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
